import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from 'react-icons/fa';
import styles from './productBulletin.module.css';

interface Props {
    text?: string;
}

// Поле bulletin может быть:
//  - JSON {am, ru, en} (мультиязычный текст),
//  - либо простой строкой (fallback для одно-язычных записей).
// Возвращает тело на текущем языке с разумным фолбэком.
function pickLocalized(raw: string, lang: string): string {
    try {
        const obj = JSON.parse(raw);
        if (obj && typeof obj === 'object') {
            const code = (lang || '').slice(0, 2);
            const order = [code, 'am', 'ru', 'en'];
            for (const k of order) {
                if (obj[k] && String(obj[k]).trim()) return obj[k];
            }
            const first = Object.values(obj).find((v) => v && String(v).trim());
            return first ? String(first) : '';
        }
    } catch {
        // не JSON — это простая строка
    }
    return raw;
}

// Заметная «доска» с техническим бюллетенем производителя.
// Рендерится только если у товара заполнено поле bulletin.
const ProductBulletin: React.FC<Props> = ({ text }) => {
    const { t, i18n } = useTranslation();
    if (!text || !text.trim()) return null;
    const body = pickLocalized(text, i18n.language);
    if (!body.trim()) return null;
    return (
        <div className={styles.bulletin} role="alert">
            <div className={styles.head}>
                <FaExclamationTriangle className={styles.icon} />
                <span className={styles.title}>{t('product_features.bulletin_title')}</span>
            </div>
            <p className={styles.body}>{body}</p>
        </div>
    );
};

export default ProductBulletin;
